import {ChangeDetectorRef, Component, inject} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {SupportApiService} from '../../services/support-api.service';
import {map, switchMap} from 'rxjs';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {AsyncPipe} from '@angular/common';
import {MatIcon} from '@angular/material/icon';
import {TopBarComponent} from '../top-bar/top-bar.component';
import {SafePipe} from '../../pipes/safe.pipe';
import {MatButton} from '@angular/material/button';
import {ProgressSpinnerComponent} from '../progress-spinner/progress-spinner.component';
import {SessionStorageService} from 'ngx-webstorage';

@Component({
  selector: 'app-standard-solution',
  imports: [
    AsyncPipe,
    TopBarComponent,
    SafePipe,
    MatButton,
    MatIcon,
    ProgressSpinnerComponent,
  ],
  templateUrl: './standard-solution.component.html',
  styleUrl: './standard-solution.component.scss'
})
export class StandardSolutionComponent {
  public display_name = '';
  public request_id = '';
  public showActions = true;
  private route: ActivatedRoute = inject(ActivatedRoute);
  private router: Router = inject(Router);
  private supportApiService: SupportApiService = inject(SupportApiService);
  private cdr: ChangeDetectorRef = inject(ChangeDetectorRef);
  private sessionStorageService: SessionStorageService = inject(SessionStorageService);
  public orderId = this.sessionStorageService.retrieve('order_id');
  public solution$ = this.route.queryParamMap.pipe(
    switchMap(params => {
      this.display_name = String(params.get('display_name'));
      this.request_id = params.get('request_id') ? String(params.get('request_id')) : '';
      this.cdr.detectChanges();
      return this.supportApiService.getHelpMessage(String(params.get('category_uuid')));
    }),
    map(data => data?.data),
    takeUntilDestroyed()
  );

  public acceptSolution() {
    this.showActions = false;
  }

  openCreateTicket() {
    this.router.navigate(['/create-ticket'], {
      queryParams: {
        display_name: this.display_name,
        category: this.route.snapshot.queryParamMap.get('category_uuid'),
        department: this.route.snapshot.queryParamMap.get('department_uuid'),
        request_id: this.request_id
      }
    });
  }
}
